var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#D8ECFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_559_719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6761 11.9292C28.1204 13.6073 24.8545 17.9912 24.8545 23.1723C24.8545 28.3533 28.1204 32.7373 32.6761 34.4153C37.2317 32.7582 40.4977 28.3533 40.4977 23.1723C40.5185 17.9912 37.2525 13.6073 32.6761 11.9292Z",
    fill: "white",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6764 31.5624C29.5145 30.0312 27.4551 26.759 27.4551 23.1721C27.4551 19.5852 29.5145 16.313 32.6972 14.7817C35.8591 16.334 37.9393 19.5852 37.9393 23.1721C37.9185 26.759 35.8591 30.0312 32.6764 31.5624Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6758 11.9292L32.6966 33.7231",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6973 34.4575V38.0024",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8946 18.9561L32.9883 25.3117",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9766 17.2778L32.3851 22.2701",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1045 22.8159L32.4268 29.5492",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8394 36.4499L18.988 34.4781V28.7937C18.7592 27.3463 17.7399 25.9619 16.3046 25.9619H15.3477L15.4517 36.1772L16.8454 38.5265C18.3432 38.3377 19.7161 37.5826 20.8394 36.4499Z",
    fill: "white",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6332 46.1407L11.978 33.1777L11.874 22.9624H12.8309C14.2663 22.9624 15.2856 24.3468 15.5144 25.7941V31.4786L17.6154 33.723L23.6272 39.7851L24.1681 39.2397L20.4237 35.485C19.4876 34.4991 19.7996 32.6533 20.7981 31.7303C20.7981 31.7303 21.0269 31.5415 21.0685 31.5206L27.7252 38.2328L28.0372 43.1202V46.7281",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6332 46.1407L11.978 33.1777L11.874 22.9624H12.8309C14.2663 22.9624 15.2856 24.3468 15.5144 25.7941V31.4786L17.6154 33.723L23.6272 39.7851L24.1681 39.2397L20.4237 35.485C19.4876 34.4991 19.7996 32.6533 20.7981 31.7303C20.7981 31.7303 21.0269 31.5415 21.0685 31.5206L27.7252 38.2328L28.0372 43.1202V46.7281",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8038 52.9999V47.8398H17.4072V52.9999",
    fill: "#9AC7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1797 36.4499L46.0311 34.4781V28.7937C46.2599 27.3463 47.2792 25.9619 48.7145 25.9619H49.6714L49.5674 36.1772L48.1737 38.5265C46.6759 38.3377 45.303 37.5826 44.1797 36.4499Z",
    fill: "white",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.365 46.1407L53.0201 33.1777L53.1242 22.9624H52.1673C50.7319 22.9624 49.7126 24.3468 49.4838 25.7941V31.4786L47.3828 33.723L41.371 39.7851L40.8301 39.2397L44.5745 35.485C45.5106 34.4991 45.1986 32.6533 44.2001 31.7303C44.2001 31.7303 43.9712 31.5415 43.9296 31.5206L37.273 38.2328L36.9609 43.1202V46.7281",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.365 46.1407L53.0202 33.1777L53.1242 22.9624H52.1673C50.7319 22.9624 49.7126 24.3468 49.4838 25.7941V31.4786L47.3828 33.723L41.371 39.7851L40.8301 39.2397L44.5745 35.485C45.5106 34.4991 45.1986 32.6533 44.2001 31.7303C44.2001 31.7303 43.9712 31.5415 43.9296 31.5206L37.273 38.2328L36.9609 43.1202V46.7281",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2158 52.9999V47.8398H47.6124V52.9999",
    fill: "#9AC7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_559_719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 42,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/registration.8d5530049aeee4b4f2bf1d5fccb84a94.svg";
export { ForwardRef as ReactComponent };